import { useState, useEffect } from "react";
import styled from "styled-components";
import SimpleModal from "~/components/SimpleModal";
import { JobIntegration } from "~/types/integrations";
import Button from "~/shared/Btn";
import { getTitle } from "~/utils/integration";
import { formatDate } from "~/utils/date";
import { LocatedJob } from "~/types/jobs";
import VistaCRMConfig from "./VistaCRMConfig";

type ExecuteIntegrationModalProps = {
    integrations: JobIntegration[];
    show: boolean;
    closeFn: () => void;
    job: LocatedJob;
    files: any[];
};

const StepList = styled.div` `;

const Step = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #dcdcdc;

    .step-number {
        width: 50px;
        text-align: center;
        background: #dcdcdc;
        border-radius: 100%;
        height: 50px;
        margin-right: 30px;
        position: relative;
    }

    .step-number > span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 2rem;
        font-weight: bold;
    }
`;

const ExecuteIntegrationModal = ({ show, files, job, integrations, closeFn }: ExecuteIntegrationModalProps) => {
    const [integration, setIntegration] = useState(integrations.length === 1 ? integrations[0] : null);

    useEffect(() => {
        if (show) {
            document.querySelector("body").style.overflow = "hidden";
            window.scrollTo(0, 0);
        }
    }, [show]);

    const close = () => {
        document.querySelector("body").style.overflow = "auto";
        closeFn();
    };

    const getIntegrationElement = () => {
        if (integration?.type === "vistacrm") {
            return (
                <VistaCRMConfig
                    job={job}
                    files={files}
                    integration={integration}
                    StepEl={Step}
                />
            );
        }

        return null;
    };

    return (
        <SimpleModal show={show} closeFn={close} size="big">
            <SimpleModal.Header>
                Integração
                {job.lastIntegration?.startDate ? (
                    <span style={{ float: "right", fontSize: "14px" }}>
                        Última execução: {formatDate(new Date(job.lastIntegration?.startDate), "dd/MM/yyyy HH:mm")}
                    </span>
                ) : (
                ""
                )}
            </SimpleModal.Header>
            <StepList style={{ padding: "10px 17px" }}>
                <Step className="step">
                    <div className="step-number"><span>1</span></div>
                    <div>
                        <h4>Qual integração deseja executar?</h4>
                        <ul className="mt-2">
                            {integrations?.map(integrat => (
                                <li key={integrat.id}>
                                    <Button
                                        variant={integrat.id === integration?.id ? "primary" : "secondary"}
                                        onClick={() => setIntegration(integrat)}
                                    >
                                        {getTitle(integrat.type)}
                                    </Button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </Step>

                {getIntegrationElement()}
            </StepList>
        </SimpleModal>
    );
};

export default ExecuteIntegrationModal;
